import {action, autorun, observable} from 'mobx';
import {nonenumerable} from 'spa/decorators';

const isServer = typeof window === 'undefined';

class localStorageHelper {
  @observable isLocalStorageActive = false;

  @nonenumerable
  listeners = [
    autorun(() => {
      try {
        this.isLocalStorageActive = !isServer && window && window.localStorage;
      } catch (error) {
        console.log('Error - localStorage');
      }
    }, {
      name: 'check localStorage exists',
    }),
  ];

  @action('getItem - localStorageHelper')
  getItem(key) {
    return (this.isLocalStorageActive && window.localStorage.getItem(key) !== 'undefined') ? JSON.parse(window.localStorage.getItem(key)) : null;
  }

  @action('setItem - localStorageHelper')
  setItem(key, value) {
    return this.isLocalStorageActive ? window.localStorage.setItem(key, JSON.stringify(value)) : null;
  }

  @action('removeItem - localStorageHelper')
  removeItem(key, value) {
    return this.isLocalStorageActive ? window.localStorage.removeItem(key) : null;
  }

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });

    try {
      this.isLocalStorageActive = !isServer && window && window.localStorage;
    } catch (error) {
      console.log('Error - localStorage');
    }
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default localStorageHelper;



// WEBPACK FOOTER //
// ./spa/state/localStorageHelper/index.jsx